<p><strong>Add Random Cuboids</strong></p>

<h3-horizontal-form [labelWidth]="2">
  <h3-horizontal-form-row>
    <span label>Number</span>
    <input [(ngModel)]="numShapes" type="number" class="form-control" />
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <mat-checkbox color="primary" [(ngModel)]="isVisible">
      Visible
    </mat-checkbox>
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <span label>% key locations</span>
    <div class="input-group">
      <span class="form-control">
        <input
          [(ngModel)]="percentageOfKeyLocationsToAdd"
          type="range"
          min="1"
          max="100"
          [disabled]="useSingleFrame"
        />
      </span>
      <span class="input-group-addon">{{ percentageOfKeyLocationsToAdd }}</span>
    </div>
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <mat-checkbox color="primary" [(ngModel)]="useSingleFrame">
      Single frame
    </mat-checkbox>
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <button class="btn btn-default" (click)="add()">Add</button>
  </h3-horizontal-form-row>
</h3-horizontal-form>
